<template>
  <div class="c-idea g-container">
    <!-- 导航 -->
    <Breadcrumb style="margin-bottom: 12px">
      <BreadcrumbItem :to="{ name: 'kuaishouplan', query: { id: formItem.campaign_id, t: 'edit' } }">
        <Icon type="ios-home-outline"></Icon> 设置推广计划
      </BreadcrumbItem>
      <BreadcrumbItem :to="{ name: 'kuaishouunit', query: { ad: formItem.ad_id, t: 'edit' } }">
        <Icon type="logo-buffer"></Icon> 设置计划组
      </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="ios-cafe"></Icon> 设置创意 </BreadcrumbItem>
    </Breadcrumb>

    <div class="module-content" ref="container">
      <moduler v-for="item in subModules" :key="item.id" :name="item.href" :title="item.name">
        <template v-if="item.href === 'idea_base'">
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">创意名称</span>
            </Col>
            <Col span="12">
              <input-len v-model="formItem.creative_name" placeholder="最大96个字符，1个中文等于2个字符" width="480" :max="96" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field">投放位置</span>
            </Col>
            <Col span="12">
              <RadioGroup :value="formItem.scene" type="button" v-if="formItem.union">
                <Radio :label="5" :disabled="editState">快手投放联盟</Radio>
              </RadioGroup>
              <RadioGroup v-model="formItem.scene" type="button" v-else @on-change="changScene">
                <Radio :label="1" :disabled="editState">优选投放位</Radio>
                <Radio :label="2" :disabled="editState">按场景选择投放位</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="formItem.scene === 2">
            <Col span="4" class="col-item">
              <span class="item-field">&nbsp;</span>
            </Col>
            <Col span="12">
              <CheckboxGroup v-model="formItem.scene_id">
                <Checkbox :label="6" :disabled="editState">上下滑大屏投放</Checkbox>
                <Checkbox :label="7" :disabled="editState">信息流投放</Checkbox>
              </CheckboxGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field">创意形式</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.unit_type" type="button" @on-change="initCreatives">
                <Radio :label="4" :disabled="editState">自定义</Radio>
                <Radio :label="7" :disabled="editState">程序化</Radio>
              </RadioGroup>
            </Col>
          </Row>
        </template>
        <template v-if="item.href === 'idea_media'">
          <!-- 自定义 -->
          <Row class="row-item" :gutter="12" v-if="formItem.unit_type === 4">
            <Col span="24">
              <creatives
                :data="formItem.creatives"
                :source="formItem.creativeDetails"
                :words="wordData"
                :game-data="gameData"
                :operator-data="operatorData"
                :max="15"
                :verify="verify"
                :scene-id="formItem.scene"
                :game-id="gameId"
                @on-splice="spliceCreative"
                @off="verify = false"
              />
            </Col>
          </Row>
          <!-- 程序化 -->
          <Row class="row-item" :gutter="12" v-else>
            <Col span="24">
              <smarts
                v-model="formItem.smart_cover"
                :data="formItem.creatives"
                :source="formItem.creativeDetails"
                :words="wordData"
                :game-data="gameData"
                :operator-data="operatorData"
                :scene-id="formItem.scene"
                :game-id="gameId"
                @on-add="pushCreative"
                @on-replace="replaceCreative"
                @on-delete="delCreative"
                @on-sticker="selectSticker"
              />
            </Col>
          </Row>
        </template>
        <template v-if="item.href === 'idea_tags'">
          <Row class="row-item" :gutter="12" v-if="isAndroid">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">应用直达URL</span>
            </Col>
            <Col span="12">
              <Input v-model="formItem.deep_link_url" placeholder="长度不能大于1024个字符" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field">高级创意</span>
            </Col>
            <Col span="12" class="col-flex">
              <i-Switch v-model="formItem.adv_card_option" :true-value="1" :false-value="0" @on-change="changeAdvCard" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field">素材挖掘</span>
            </Col>
            <Col span="12" class="col-flex">
              <i-Switch v-model="formItem.asset_mining" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field">自动发送礼包码</span>
            </Col>
            <Col span="12" class="col-flex">
              <i-Switch v-model="formItem.gift" @on-change="changeGift" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="isAndroid && formItem.gift">
            <Col span="1">&nbsp;</Col>
            <Col span="3" class="col-item">
              <span class="item-field">发送时机</span>
            </Col>
            <Col span="12" class="col-flex">
              <RadioGroup type="button" v-model="formItem.target_action_type">
                <Radio :label="30">开始下载后</Radio>
                <Radio :label="31">下载完成后</Radio>
                <Radio :label="32">安装完成后</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="formItem.gift">
            <Col span="1">&nbsp;</Col>
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">礼包码</span>
            </Col>
            <Col span="12" class="col-flex">
              <input-len v-model="formItem.code" placeholder="最大20个字符，1个中文等于2个字符" :max="20" style="width: 480px" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">创意分类</span>
            </Col>
            <Col span="12">
              <category :title="['创意分类']" :value="formItem.mult_categroy" :data="categroyData" @on-select="selectCategroy" />
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">创意标签</span>
            </Col>
            <Col span="12">
              <add-tags v-model="formItem.creative_tag" :open-id="opId" @on-close="closeTag" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field">点击监测链接</span>
            </Col>
            <Col span="12">
              <Input :value="formItem.click_track_url" readonly placeholder="内部计划自动生成" />
            </Col>
          </Row>
        </template>
      </moduler>

      <div class="c-idea-submit">
        <Row :gutter="12">
          <Col span="12">
            <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []" />
          </Col>
          <Col span="12" class="c-btns-submit">
            <Button type="default" @click="cannel">取消</Button>
            <Button type="primary" v-if="editState" :loading="saving" @click.stop="verifyElementAll('save')">
              <span v-if="!saving">保存</span>
              <span v-else>提交中...</span>
            </Button>
            <Button type="primary" v-else :loading="loading" @click.stop="verifyElementAll('next')">
              <span v-if="!loading">完成</span>
              <span v-else>提交中...</span>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from './mixin'
import { isArray } from '@/common/js/utils'
import categroyData from '@/data/kuaishou/ad_categroy'

import Category from '@/views/create/kuaishou_local/components/idea/selecter/category.vue'
import AddTags from '@/views/create/kuaishou_local/components/idea/selecter/add-tags.vue'
import Creatives from '@/views/create/kuaishou_local/components/idea/creative/creative'
import Smarts from '@/views/create/kuaishou_local/components/idea/creative/smart'

import { getCaohuaPlan } from '@/api/common.model'
import { getCreative, getCreativeWords, getCreativeCategory, getCreativeStyles } from '@/api/kuaishou.model'

const defautWords = ['日期', '星期', '节日', '年龄范围', '地区']

export default {
  name: 'kIdea',
  mixins: [mixin],
  components: { Category, AddTags, Creatives, Smarts },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    isAndroid() {
      return this.platform === 1
    }
  },
  data() {
    return {
      saving: null,
      loading: null,
      formErr: null,
      errRes: [],

      formItem: {
        creative_name: '',
        union: null,
        scene: null,
        scene_id: null,
        unit_type: 0,

        creatives: [], // 创意数组
        creativeDetails: [],
        adv_card_option: 0,
        adv_card_list: [],
        card_type: 101,
        gift: false, // 发送礼包码
        target_action_type: 30,
        code: '',
        asset_mining: false, // 素材挖掘
        smart_cover: 0,
        creative_category: 0,
        creative_tag: [],
        mult_categroy: []
      },
      ad_id: Number(this.$route.params.ad), // 计划ID
      campaign_id: Number(this.$route.params.id), // 广告组ID
      ch_plan_id: Number(this.$route.query.plan), // 内部计划
      campaignType: '',
      platform: 0,
      gameId: 0,
      categroyData: categroyData,
      styleData: [],
      wordData: []
    }
  },
  methods: {
    getData() {
      getCreative({
        ad_account_id: this.account,
        ad_id: this.ad_id
      })
        .then((data) => {
          this.$Spin.hide()
          console.log(data)
          if (data && isArray(data.creatives)) {
            const [creative] = data.creatives // 取出第一个
            this.formItem.creative_name = creative.creative_name
            this.formItem.creatives = data.creatives.map((ret) => {
              const adcreative = {}
              if (ret.unit_type === 4) {
                // 自定义创意
                if (ret.creative_material_type === 1) {
                  // 竖版
                } else if (ret.creative_material_type === 2) {
                }
              } else if (ret.unit_type === 7) {
                // 程序化创意
              }
              return adcreative
            })
            this.formItem.creativeElements = []
            this.formItem.creativeDetails = data.creatives_detail
            this.formItem.mult_categroy = creative.mult_categroy.map((ret) => {
              return {
                id: ret.category_id,
                value: ret.category_name,
                level: ret.level,
                parent: ret.parent_id
              }
            })
            this.formItem.creative_tag = creative.creative_tag
            this.formItem.click_track_url = creative.click_track_url
          } else this.$Message.error('未找到该计划组下的创意！')
        })
        .catch((err) => {
          this.$Message.error(err)
          console.error(err)
        })
    },
    changeAdvCard(val) {
      console.log(val)
    },
    changeGift(val) {
      if (val) {
        this.formItem.target_action_type = this.isAndroid ? 30 : 2
        this.formItem.code = ''
        console.log(this.formItem.target_action_type)
      }
    },
    closeTag(name) {
      const index = this.formItem.creative_tag.findIndex((ret) => ret === name)
      if (index > -1) this.formItem.creative_tag.splice(index, 1)
    },
    selectCategroy(item) {
      this.formItem.mult_categroy = item
    },
    proLoadData() {
      const param = { ad_account_id: this.account }
      this.$Spin.show()
      Promise.all([
        getCreativeWords(param),
        getCreativeCategory(param),
        getCreativeStyles(param),
        getCaohuaPlan({ account: this.account, id: this.ad_id })
      ])
        .then((data) => {
          if (isArray(data)) {
            const [words, categories, styles, info] = data
            const { plan_info, out_plan_info } = info
            if (isArray(words)) {
              this.wordData = words
                .filter((ret) => defautWords.includes(ret.name))
                .map((ret) => {
                  ret.max_word_length += ret.max_word_length
                  return ret
                })
            }
            if (isArray(categories)) this.categroyData = categories
            if (isArray(styles)) this.styleData = styles
            if (plan_info) {
              this.gameId = parseInt(plan_info.game_id)
              this.platform = parseInt(plan_info.ch_platform_id)
              this.$set(this.formItem, 'creative_name', plan_info.plan_name)
            }
            if (out_plan_info) {
              const { unit_type, scene_id, asset_mining, adv_card_option, gift_data, smart_cover } = out_plan_info
              // 优选/联盟/按场景
              if (isArray(scene_id) && scene_id.includes(1)) this.formItem.scene = 1
              else if (isArray(scene_id) && scene_id.includes(5)) {
                this.formItem.scene = 5
                this.formItem.union = true
              } else this.formItem.scene = 2
              this.formItem.scene_id = scene_id
              this.formItem.asset_mining = asset_mining
              this.formItem.smart_cover = Number(smart_cover)
              this.formItem.unit_type = unit_type
              this.formItem.adv_card_option = adv_card_option
              this.formItem.gift = Boolean(gift_data)
              if (this.formItem.gift) {
                const { target_action_type, code } = gift_data
                this.formItem.target_action_type = target_action_type
                this.formItem.code = code
              }
            }
            if (this.editState) this.getData()
            else this.$Spin.hide()
          } else {
            this.$Message.error('获取外部计划组信息时出错！')
            this.$Spin.hide()
          }
        })
        .catch((err) => {
          this.$Spin.hide()
          console.error(err)
        })
    },
    verifyElementAll() {}
  },
  created() {
    if (this.editState) this.beforeHandler()
    this.proLoadData()
  }
}
</script>
<style lang="scss" scoped>
.row-item {
  align-items: flex-start;

  span.item-field {
    height: 32px;
    line-height: 32px;
  }
}

.c-idea {
  position: relative;
  height: inherit;

  .m-bread {
    line-height: 20px;
    margin-bottom: 12px;
  }

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 96px);
  }

  .col-flex {
    min-height: 32px;
    display: flex;
    align-items: center;
  }

  .c-idea-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      button {
        margin-left: 8px !important;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}
</style>
